import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section id="home" className="hero-section">
      <div className="hero-content">
        <div className="container">
          <motion.div 
            className="hero-text"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Trusted General Contractor in Waddy, Kentucky</h1>
            <p className="lead">
              Your reliable partner for commercial and residential construction projects throughout 
              Kentucky and the greater Louisville region. We deliver exceptional construction 
              solutions with unwavering commitment to quality, safety, and client satisfaction.
            </p>
            <div className="hero-credentials">
              <span>Licensed</span>
              <span>Insured</span>
              <span>Locally Owned & Operated</span>
            </div>
            <div className="hero-buttons">
              <a href="#contact" className="btn btn-primary btn-lg">Get a Quote</a>
              <a href="#services" className="btn btn-outline-primary btn-lg">Our Services</a>
              <a href="#service-area" className="btn btn-outline-primary btn-lg">Service Area</a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
